var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-print-view-warning text-dark"},[_c('font-awesome-icon',{staticClass:"mr-2 h1",attrs:{"icon":['fad', 'info-circle']}}),_c('div',[_c('div',{staticClass:"h6 mb-1"},[_vm._v(_vm._s(_vm.warning_title))]),_c('div',{staticClass:"small"},[_vm._v(_vm._s(_vm.warning_text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }